module.exports = __webpack_public_path__ + "static/media/3.c7adf815.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/Artists/01/projects/01/3.jpg
// module id = 394
// module chunks = 0